import { CheckCircle2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import type { OnboardingEdition } from '@/types';
import { ConfettiEffect } from './ConfettiEffect';
import { OnboardingShell, titleFont } from './OnboardingShell';

// _components/onboarding-complete.tsx. The "Créditos Anthropic registrados" line is only
// there for the editions that asked for them (PORTING.md G5).
export function OnboardingComplete({
  edition,
  hackerFullName,
}: {
  edition: OnboardingEdition;
  hackerFullName: string;
}) {
  return (
    <>
      <ConfettiEffect />
      <OnboardingShell ph26={edition.ph26} width="max-w-2xl">
        {/* Title */}
        <div className="text-center">
          <h1
            className={`inline-block font-bold ${titleFont(edition.ph26)} text-2xl text-primary sm:text-3xl md:text-4xl`}
          >
            ¡Onboarding{' '}
            <span className="bg-primary px-2 py-1 text-background">
              Completo!
            </span>
          </h1>
          <p className="mt-4 font-mono text-primary/70 text-sm">
            {`Ya estás listo para ${edition.eventName}`}
          </p>
        </div>

        {/* Success Card */}
        <div className="border-2 border-primary bg-background/80 p-6 backdrop-blur-sm sm:p-8 md:p-10">
          <div className="space-y-6">
            <div className="flex flex-col items-center gap-6">
              <div className="rounded-full bg-green-500 p-6">
                <CheckCircle2 className="h-16 w-16 text-white" />
              </div>

              <div className="flex flex-col items-center gap-2 text-center">
                <h2
                  className={`font-bold ${titleFont(edition.ph26)} text-2xl text-primary`}
                >
                  ¡Todo listo, {hackerFullName.split(' ')[0]}!
                </h2>
                <p className="font-mono text-primary/70 text-sm">
                  Has completado todos los pasos del onboarding
                </p>
              </div>
            </div>

            <div className="border-primary/20 border-t pt-6">
              <div className="space-y-3">
                <div className="flex items-center gap-3">
                  <CheckCircle2 className="h-5 w-5 text-green-600" />
                  <span className="font-mono text-sm">GitHub conectado</span>
                </div>
                <div className="flex items-center gap-3">
                  <CheckCircle2 className="h-5 w-5 text-green-600" />
                  <span className="font-mono text-sm">Discord conectado</span>
                </div>
                <div className="flex items-center gap-3">
                  <CheckCircle2 className="h-5 w-5 text-green-600" />
                  <span className="font-mono text-sm">
                    Información completada
                  </span>
                </div>
                {edition.collectsAnthropicCredits && (
                  <div className="flex items-center gap-3">
                    <CheckCircle2 className="h-5 w-5 text-green-600" />
                    <span className="font-mono text-sm">
                      Créditos Anthropic registrados
                    </span>
                  </div>
                )}
              </div>
            </div>

            <div className="flex justify-center pt-4">
              <Button
                size="lg"
                className="w-full sm:w-auto"
                onClick={() => {
                  window.location.href = '/hacker/dashboard';
                }}
              >
                Ir al Dashboard
              </Button>
            </div>
          </div>
        </div>
      </OnboardingShell>
    </>
  );
}
